import { useEffect, useState } from "react";

export function ExpligoBadge() {
    const [expanded, setExpanded] = useState(true);
    const [intro, setIntro] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
     useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (isMobile) {
        setIntro(true);
        setExpanded(true);

        const introTimer = setTimeout(() => {
            setIntro(false); 
            setExpanded(false);

            const collapseTimer = setTimeout(() => {
            setExpanded(true); 
            }, 3500);

            return () => clearTimeout(collapseTimer);
        }, 800);

        return () => clearTimeout(introTimer);
        }
    }, [isMobile]);

    return (
        <>
          {!isMobile ? (
            <div style={{"position": "fixed", "boxShadow": "rgba(40, 62, 88, 0.47) 0px 0px 8px 0px", "padding": "0.25rem", "top": "1rem", "right": "1rem", "background": "#233040", "borderRadius": "1rem", "display": "flex", alignItems: "center" ,zIndex: 9999,}}>
                <img style={{"height": "4rem", objectFit: "cover"}} src="/images/expligo_abstract_5.png" alt={"Expligo logo"}/>
                <div style={{"color": "#ccc", marginRight: "0.75rem"}}>
                    Powered by <b>Expligo</b>
                    <br/>
                    <a style={{fontSize: "0.7rem", color: "#888"}} target="_blank" href="https://expligo.nl/utility-pages/voorwaarden-verwerking">Algemene voorwaarden</a>
                </div>
            </div> ) : (
                <a href="https://expligo.nl/utility-pages/voorwaarden-verwerking" target="_blank" rel="noopener noreferrer" className={`expligo-badge ${intro ? "intro" : expanded ? "expanded" : "collapsed" }`} >
                    <img src="/images/expligo_abstract_5.png" alt="Expligo logo" />
                    <div className="expligo-text">
                        Powered by <b>Expligo</b>
                    </div>
                </a>
            )}
        </>
    )
}
